module.exports = __webpack_public_path__ + "f8be4cf5a778238e20adcf3e436fcedb.svg";